{
  "queryName": "curatorList",
  "queryParam": null,
  "fields": ["username", "id", "role"]
}
